import React from 'react';
import { scrollToId } from '../../utilities/scrollUtilities';

const LEVELCLASS = ['', 'level1', 'level2', 'level3', 'level4', 'level5'];

const onClickHeader = (e, id, isDraft) => {
    if (isDraft) {
        e.preventDefault();
        scrollToId(id);
    }
};

const PageTitle = ({ title, isDraft }) => {
    if (!title) return null;
    return (
        <li className="toc-section" key={title}>
            <a href="#page-top" className="bold level1" onClick={e => onClickHeader(e, 'page-top', isDraft)}>
                {title}
            </a>
        </li>
    );
};

export default ({ data, title, isDraft }) => {
    if (!data || !data.length) return null;

    const list = data.map(entry => (
        <li
            className="toc-section"
            key={entry.key}
        >
            <a href={`#${entry.id}`} onClick={e => onClickHeader(e, entry.id, isDraft)} className={LEVELCLASS[entry.level]}>
                {entry.text}
            </a>
        </li>
    ));

    return (
        <ul className="toc">
            <PageTitle title={title} isDraft={isDraft} />
            {list}
        </ul>
    );
};
